import { FC } from 'react'
import { AccountActionUpdateHandler } from 'components/features/pfm/AccountActionHandler/AccountActionUpdateHandler'
import { AccountActionContinueHandler } from 'components/features/pfm/AccountActionHandler/AccountActionContinueHandler'
import Button from 'components/features/pfm/Button/Button'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountTooltipActionProps = {
  accountInfo: MixedAccountsTableItem
}
export const AccountTooltipAction: FC<AccountTooltipActionProps> = (props) => {
  const { accountInfo } = props

  return (
    <>
      <AccountActionContinueHandler accountInfo={ accountInfo }>
        <Button
          qaMarker='linked-account-continue'
          size='micro'
          theme='lightBlue'
        >
          Continue
        </Button>
      </AccountActionContinueHandler>

      <AccountActionUpdateHandler accountInfo={ accountInfo } kind='retry'>
        <Button
          qaMarker='linked-account-retry'
          size='micro'
          theme='lightBlue'
        >
          Retry
        </Button>
      </AccountActionUpdateHandler>

      <AccountActionUpdateHandler accountInfo={ accountInfo } kind='update_credentials'>
        <Button
          qaMarker='linked-account-update_credentials'
          size='micro'
          theme='lightBlue'
        >
          Update Credentials
        </Button>
      </AccountActionUpdateHandler>

    </>
  )
}
